<template>
  <div></div>
</template>

<script>

export default {
  created() {
    console.log(this.$route.query);

    let qKeys = Object.keys(this.$route.query);

    if (qKeys.length === 0) return;

    // 用户的信息
    let userOrder = this.$route.query.userOrder;

    let userInfo = userOrder.split("|")[0];
    localStorage.setItem("userinfo", JSON.stringify(userInfo));

    localStorage.setItem('userOrder' , userOrder)

    // 跳转的页面
    let routing = "/" + this.$route.query.query;
    console.log(routing);

    // 参数
    let params = this.$route.query.param;
    console.log(params.split("-"));

    var paramObj = {};

    params.split("-").forEach((param) => {
      let paramArr = param.split("|");
      paramObj[paramArr[0]] = paramArr[1];
    }); 

    console.log(paramObj);

    this.$router.push({
      path: routing,
      query: paramObj,
    });
  },
};
</script>

<style>
</style>